import gql from 'graphql-tag';

const MUTATION_GENERATE_COMMISSION_REPORT = gql`
	mutation GenerateCommissionReport($month: Int!, $year: Int!) {
		generateCommissionReport(month: $month, year: $year)
	}
`;

export default MUTATION_GENERATE_COMMISSION_REPORT;